/*
BEDROCK Core
Copyright (c) 2026 Patrick Schimmelpfennig

All rights reserved.

Unauthorized copying, modification, distribution or use of this software,
in whole or in part, is strictly prohibited without explicit written permission
from the author or an authorized BEDROCK license grant.
*/

export const relationEntity = {

    entity: "relation",
    label: "Relation",

    fields: [

        {
            key: "relation_id",
            label: "ID",
            type: "uuid",
            visible: false,
            editable: false
        },

        {
            key: "origin_entity",
            label: "Origin Entity",
            type: "text",
            required: true,
            visible: true,
            editable: true
        },

        {
            key: "origin_id",
            label: "Origin ID",
            type: "uuid",
            visible: true,
            editable: true
        },

        {
            key: "target_entity",
            label: "Target Entity",
            type: "text",
            required: true,
            visible: true,
            editable: true
        },

        {
            key: "target_id",
            label: "Target ID",
            type: "uuid",
            visible: true,
            editable: true
        },

        {
            key: "relation_type",
            label: "Type",
            type: "text",
            visible: true,
            editable: true
        },

        {
            key: "relation_status",
            label: "Status",
            type: "select",
            options: ["active", "inactive"],
            visible: true,
            editable: true
        },

        {
            key: "created_at",
            label: "Created",
            type: "datetime",
            visible: false,
            editable: false
        }

    ]

}